import Tooltip from './Tooltip';
import { isMobile } from 'react-device-detect';

/**
 * @class HotspotTooltip
 * @extends Tooltip
 *
 * @category Hotspot
 * @subcategory Components
 *
 *
 * @constructor
 *
 * @param {object} params
 * @param {object} tooltipConfig
 *
 * @returns {object}
 *
 */
class HotspotTooltip extends Tooltip {
	constructor(params, tooltipConfig = {}, onMouseUp) {
		super(params);

		this.tooltipConfig = tooltipConfig;
		this.inactiveTimer = null;
		this.exitTimer = null;

		this.image = {
			style: params?.image?.style || {
				width: '15px',
				height: 'auto',
			},
			url: params?.image?.url || '',
		};
		this.onMouseUp = onMouseUp;
	}

	mount = () => {
		this.initHTML().then(() => {
			this.initialized = true;
			this.image.url && this.setImageContent(this.image);
			if (
				(!isMobile &&
					this.tooltipConfig?.desktop_type?.includes('persistent')) ||
				(isMobile &&
					this.tooltipConfig?.mobile_type?.includes('persistent'))
			) {
				this.setTooltipStatus(true, 'persistent');
			}

			if (
				(!isMobile &&
					this.tooltipConfig?.desktop_type?.includes('inactivity')) ||
				(isMobile &&
					this.tooltipConfig?.mobile_type?.includes('inactivity'))
			) {
				this.inactiveTimer = setTimeout(() => {
					this.setTooltipStatus(true, 'inactivity');
				}, this.tooltipConfig.inactivity_timer * 1000);
				document.addEventListener('click', this.onInactiveClick);
			}
		});
	};

	setImageContent = (imageConfig) => {
		const image = document.createElement('img');
		image.src = imageConfig.url;
		for (let key of Object.keys(imageConfig.style)) {
			image.style[key] = imageConfig.style[key];
		}
		image.style.pointerEvents = 'all';
		image.role = 'button';
		image.onclick = this.onMouseUp;
		this.labelDiv.appendChild(image);
	};

	onInactiveClick = () => {
		clearTimeout(this.inactiveTimer);
		document.removeEventListener('click', this.onInactiveClick);
	};

	onClickHide = () => {
		if (this.config.active) {
			this.setTooltipStatus(false, 'click');
		}
	};

	setTooltipStatus = (status, origin) => {
		if (status) {
			clearTimeout(this.inactiveTimer);
			if (isMobile) {
				if (origin === 'inactivity') {
					this.exitTimer = setTimeout(() => {
						this.setTooltipStatus(false, 'exit');
					}, this.tooltipConfig.exit_delay * 1000);
				}
				if (origin === 'click') {
					document.addEventListener('click', () => {
						this.onClickHide();
					});
				}
			} else {
				if (origin === 'inactivity') {
					this.exitTimer = setTimeout(() => {
						this.setTooltipStatus(false, 'exit');
					}, this.tooltipConfig.exit_delay * 1000);
				}
				if (origin === 'click') {
					document.addEventListener('mousedown', () => {
						this.onClickHide();
					});
				}
			}
		} else {
			clearTimeout(this.exitTimer);
			if (isMobile) {
				document.removeEventListener('click', () => {
					this.onClickHide();
				});
			} else {
				if (origin === 'click') {
					document.removeEventListener('mousedown', () => {
						this.onClickHide();
					});
				}
			}
		}
		this.config.active = status;
		this.containerDiv.style.opacity = status ? '1' : '0';
	};
}

export default HotspotTooltip;
